import React from "react";
import { ErrorList, ErrorStrings } from "../../../components/Enums";
import {
    ErrorText,
    PortalFormFieldGroup,
    PortalFormFieldRow,
    PortalFormLabel,
    ValidatedDateInput
} from "src/components";
import Skeleton from "src/scenes/Statistics/components/Skeleton";
import { SurveyStatusType } from "src/constants/survey";

export const SurveyDurationFields = (props) => {
    const { survey, inputStartDate, inputFinishDate, inputErrors, isEditSurveyForm, loading } = props;

    const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);

    const surveyStartDateError = getErrorStrings(ErrorList.EMPTY_START_DATE);
    const surveyFinishDateError = getErrorStrings(ErrorList.EMPTY_FINISH_DATE);

    const startDateInvalid = getErrorStrings(ErrorList.DATE_START_DATE_INVALID);
    const finishDateInvalid = getErrorStrings(ErrorList.DATE_FINISH_DATE_INVALID);

    const dateStartFormatInvalid = getErrorStrings(ErrorList.DATE_START_FORMAT_INVALID);
    const dateFinishFormatInvalid = getErrorStrings(ErrorList.DATE_FINISH_FORMAT_INVALID);

    const dateRangeInvalid = getErrorStrings(ErrorList.DATE_RANGE_INVALID);

    const durationErrorMessages = [
        ...startDateInvalid,
        ...finishDateInvalid,
        ...dateStartFormatInvalid,
        ...dateFinishFormatInvalid,
        ...dateRangeInvalid
    ];

    return (
        <>
            <PortalFormFieldRow>
                <PortalFormFieldGroup>
                    <PortalFormLabel>
                        Start Date
                    </PortalFormLabel>
                    {loading ?
                        <Skeleton height="46px" width="100%" animation="wave" />
                        :
                        <ValidatedDateInput
                            placeholder="Select date"
                            onChange={(event) => {inputStartDate(event);} }
                            errors={surveyStartDateError}
                            value={survey.startDate}
                            disabled={isEditSurveyForm && survey.status !== SurveyStatusType.SCHEDULED}
                            showErrors={surveyStartDateError.length > 0}
                        />
                    }
                </PortalFormFieldGroup>
                <PortalFormFieldGroup>
                    <PortalFormLabel>
                        Finish Date
                    </PortalFormLabel>
                    {loading ?
                        <Skeleton height="46px" width="100%" animation="wave" />
                        :
                        <ValidatedDateInput
                            placeholder="Select date"
                            onChange={(event) => {inputFinishDate(event);} }
                            errors={surveyFinishDateError}
                            value={survey.finishDate}
                            disabled={false}
                            showErrors={surveyFinishDateError.length > 0}
                        />
                    }
                </PortalFormFieldGroup>
            </PortalFormFieldRow>
            
            <ErrorText errorMargin="0px">{durationErrorMessages.join(" ")}</ErrorText>
        </>
    );
};
